<template>
    <el-container class="assets-page" v-wechat-title="$route.meta.title">
        <el-container>
            <el-container>
                <el-main class="el-main">
                    <div class="table-title column-header">
                        <div class="table-title-left">
                            <span><i class="fa fa-pie-chart" aria-hidden="true"></i> 权益</span>
                            <!-- <el-checkbox v-model="totalChecked" @change="apiTotalEvent">所有</el-checkbox> -->
                            <!-- <select v-model="apiSelected" @change="apiSelectEvent">
                                <option v-for="(api, index) in apiNameList" :key="index" :label="api.name" :value="index">{{api.name}}</option>
                            </select> -->
                            <!-- <el-button class="btn__style" @click="apiTotalAsset">所有API</el-button> -->
                            <el-button class="btn__style" size="small" @click="getSnapshot">资产快照</el-button>
                            <el-button class="btn__style" size="small" @click="handleRestore">继续跟随</el-button>
                        </div>
                        <div class="table-title-contral">
                            <el-button class="btn__style" @click="getAssetChart">图表 <i class="fa fa-line-chart" aria-hidden="true"></i></el-button>
                        </div>
                        <el-dialog :visible.sync="dialogVisible" width="50%">
                            <div class="chart-title">
                                <h3>资产比率曲线</h3>
                                <div class="chart-select">
                                    <div class="chart-time-select">
                                        <span @click="changeChart(1)" :style="{'color': dateTimeBgc(1)}"><strong>10分钟</strong></span>
                                        <span @click="changeChart(2)" :style="{'color': dateTimeBgc(2)}"><strong>1小时</strong></span>
                                        <span @click="changeChart(3)" :style="{'color': dateTimeBgc(3)}"><strong>1天</strong></span>
                                        <span @click="changeChart(4)" :style="{'color': dateTimeBgc(4)}"><strong>1周</strong></span>
                                        <span @click="changeChart(5)" :style="{'color': dateTimeBgc(5)}"><strong>1月</strong></span>
                                    </div>
                                    <el-divider direction="vertical"></el-divider>
                                    <div class="chart-time-select">
                                        <span @click="currecncySelect('u')" :style="{'color': currencyHigh('u')}">USDT</span>
                                        <span @click="currecncySelect('b')" :style="{'color': currencyHigh('b')}">币</span>
                                    </div>
                                </div>
                            </div>
                            <div class="chart">
                                <AssetChart ref="assetChart"></AssetChart>
                            </div>
                        </el-dialog>
                    </div>

                    <div class="total-statistic" v-show="isShow">
                        <AssetNew></AssetNew>
                    </div>
                    <div class="classify-content">
                        <ul>
                            <li :class="{'active1': 0 == id.apiId}"  @click="apiTotalAsset">所有API</li>
                            <li v-for="(api, index) in apiNameList" :key="index" @click.self="apiSelect(api, $event, index)" :class="{'active1': id.apiId == api.id}">
                                <!-- <el-checkbox :key="api.id" @change="checkboxEvent($event, api.id)" style="display: none;"></el-checkbox> -->
                                {{api.name}}
                                <!-- <apiUChart :apiId="api.id" :chartUData="apiUchartData"/> -->
                            </li>
                        </ul>
                    </div>
                    <div class="table-description" v-show="!isShow" v-if="isTable"> 
                        <div class="asset-total">
                            <div class="asset-total-box">
                                <div class="asset-total-title" title="减去了用于抵押的价值">
                                    <div class="asset-title-item">
                                        <span>净资产（USDT）: </span>
                                        <span>{{statisticData["total_equity(USDT)"]}}</span>
                                    </div>
                                    <div class="asset-title-item" style="flex: 1.5;">
                                        <span>本金价值（USDT）: </span>
                                        <span>{{ statisticData['principal/surplus(USDT)'] }}</span>
                                    </div>
                                    <div class="asset-title-item">
                                        <span>总持仓：</span>
                                        <span>{{statisticData['total_position']}}</span>
                                    </div>
                                </div>
                                <div class="asset-total-body">
                                    <div class="asset-total-item" v-if="calUsedRate">
                                        <span class="asset-item-name">(期货已用+抵押已用)/总净资产：</span>
                                        <span class="asset-item-progress"><NewProgress :myWidth="180" :myHeight="18" :typeNum='1' :progressWidth="calUsedRate"></NewProgress></span>
                                        <span class="assets-item-value">({{calUsedRate['future']}}+{{calUsedRate['borrow']}})/{{calUsedRate['total']}}</span>
                                    </div>
                                    <div class="asset-total-item">
                                        <span class="asset-item-name">净总资产已用/闲置/总净资产：</span>
                                        <span class="asset-item-progress"><MyProgress :myWidth="180" :myHeight="18" :typeNum='1' :proressWidth="statisticData['total_used/surplus(USDT)']"></MyProgress></span>
                                        <span class="assets-item-value">{{dataProcess(statisticData['total_used/surplus(USDT)'])}}</span>
                                    </div>
                                    <div class="asset-total-item">
                                        <span class="asset-item-name">期货已用/闲置/总占用：</span>
                                        <span class="asset-item-progress"><MyProgress :myWidth="180" :myHeight="18" :proressWidth="statisticData['futures_used/surplus(USDT)']"></MyProgress></span>
                                        <span class="assets-item-value">{{dataProcess(statisticData['futures_used/surplus(USDT)'])}}</span>
                                    </div>
                                    <div class="asset-total-item">
                                        <span class="asset-item-name">永续已用/闲置/总占用：</span>
                                        <span class="asset-item-progress"><MyProgress :myWidth="180" :myHeight="18" :proressWidth="statisticData['swap_used/surplus(USDT)']"></MyProgress></span>
                                        <span class="assets-item-value">{{dataProcess(statisticData['swap_used/surplus(USDT)'])}}</span>
                                    </div>
                                    <div class="asset-total-item">
                                        <span class="asset-item-name">借贷抵押已用/闲置/总可抵押：</span>
                                        <span class="asset-item-progress"><MyProgress :myWidth="180" :myHeight="18" :proressWidth="statisticData['borrow_pledge_used/surplus(USDT)']"></MyProgress></span>
                                        <span class="assets-item-value">{{dataProcess(statisticData['borrow_pledge_used/surplus(USDT)'])}}</span>
                                    </div>
                                    <div class="asset-total-item">
                                        <span class="asset-item-name">净借已用/净剩余可借/净总可借：</span>
                                        <span class="asset-item-progress"><MyProgress :myWidth="180" :myHeight="18" :proressWidth="statisticData['borrow_used/surplus(USDT)']"></MyProgress></span>
                                        <span class="assets-item-value">{{dataProcess(statisticData['borrow_used/surplus(USDT)'])}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="borrow-content">
                            <el-tabs v-model="tagActive" type="border-card" @tab-click="handleTabClick">
                                <el-tab-pane label="API 统计" name="static">
                                    <AssetApiChart ref="apiChart" v-if="tabIndex == 0" :type="apiCType"/>
                                    <div class="static-info">
                                        <ul>
                                            <li>
                                                <!-- <el-button class="btn__style" @click="refreshChart">刷新</el-button> -->
                                                <el-button class="btn__style" @click="apiTypeChange('u')"
                                                :style="{'color': apiCType == 'u'?'#db5634': ''}">USDT</el-button>
                                                <el-button class="btn__style" @click="apiTypeChange('b')"
                                                :style="{'color': apiCType == 'b'?'#db5634': ''}">币</el-button>
                                            </li>
                                            <li>
                                                <el-button class="btn__style" @click="apiChartChange(1)"
                                                :style="{'color': apiDate == 1?'#db5634': ''}">10分钟</el-button>
                                                <el-button class="btn__style" @click="apiChartChange(2)"
                                                :style="{'color': apiDate == 2?'#db5634': ''}">1H</el-button>
                                                <el-button class="btn__style" @click="apiChartChange(3)"
                                                :style="{'color': apiDate == 3?'#db5634': ''}">1D</el-button>
                                                <el-button class="btn__style" @click="apiChartChange(4)"
                                                :style="{'color': apiDate == 4?'#db5634': ''}">1W</el-button>
                                                <el-button class="btn__style" @click="apiChartChange(5)"
                                                :style="{'color': apiDate == 5?'#db5634': ''}">1M</el-button>
                                            </li>
                                            <!-- <li>净资产(USDT)：{{apiStaticData.total_equity}}</li>
                                            <li>本金价值（USDT)：{{apiStaticData['principal/surplus(USDT)']}}</li>
                                            <li>总持仓：{{apiStaticData.total_position}}</li> -->
                                        </ul>
                                    </div>
                                </el-tab-pane>
                                <el-tab-pane label="交易记录" name="trade">
                                    <TradeDetail :apiId="id.apiId" v-if="tabIndex == 1" ref="tradeNode"></TradeDetail>
                                </el-tab-pane>
                                <el-tab-pane label="转账记录" name="transfer">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>币种</th>
                                                <th>转账数量</th>
                                                <th>转账类型</th>
                                                <th>转账时间</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index_log) in assetBorrowData.ledger" :key="'log-'+index_log">
                                                <td>{{item['currency']}}</td>
                                                <td>{{item['amount'].toFixed(2)}}</td>
                                                <td>{{item['type_']}}</td>
                                                <td>{{item['trade_time']}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </el-tab-pane>
                                <el-tab-pane label="借贷记录" name="borrow">
                                    <div class="borrow-info-body" v-if="assetBorrowData.borrow.length == 0">
                                        <div class="borrow-info-item" style="text-align: center">暂无借贷记录!</div>
                                    </div>
                                    <div class="borrow-info-body" v-else>
                                        <div class="borrow-info-item" v-for="(item, index) in assetBorrowData.borrow" :key="'bor-'+index">{{index+1+'. '+item}}</div>
                                    </div>
                                </el-tab-pane>
                                <el-tab-pane label="手动交易" name="trading" v-if="id.apiId">
                                    <ManulTrade :apiId="id.apiId"></ManulTrade>
                                </el-tab-pane>
                            </el-tabs>
                        </div>                      
                    </div>
                    <div class="table-content" v-show="!isShow">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th v-for="(name, index) in assetsTableHeader" :key="index">{{name}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in tableList" :key="index">
                                    <td>
                                        <el-popover width="500" trigger="click" placement="right">
                                            <div class="chart">
                                                <AssetCurrencyChart ref="assetChart1"></AssetCurrencyChart>
                                            </div>
                                            <el-button slot="reference" @click="showCurrencyChart(item.currency, index)">{{item.currency}}</el-button>
                                        </el-popover>                                       
                                    </td>
                                    <td>{{item.spot}}</td>
                                    <td>{{item['futures']}}</td>
                                    <td>{{item['P_CW']}}</td>
                                    <td>{{item['P_NW']}}</td>
                                    <td>{{item['P_CQ']}}</td>
                                    <td>{{item['P_NQ']}}</td>
                                    <td>{{item['P_CS']}}</td>
                                    <td>{{item['F_CW']}}</td>
                                    <td>{{item['F_NW']}}</td>
                                    <td>{{item['F_CQ']}}</td>
                                    <td>{{item['F_NQ']}}</td>
                                    <td>{{item['F_CS']}}</td>
                                    <td>{{item['wallet']}}</td>
                                    <td>{{item['transfer']}}</td>
                                    <td>{{item['self_worth']}}</td>
                                    <td>{{item['price']}}</td>
                                    <td>{{item['principal']}}</td>
                                    <td>{{item['principal_usdt']}}</td>
                                    <td>{{item['proportion %']}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </el-main>
            </el-container>
        </el-container>
    </el-container>
</template>

<script>
/* eslint-disable */
import AssetChart from '@/views/assets/Asset-chart.vue'
import AssetCurrencyChart from '@/views/assets/Asset-currency-chart.vue'
import AssetApiChart from "@/views/assets/Asset-api-chart.vue";
import MyProgress from '@/components/My-progress.vue'
import NewProgress from '@/components/My-progress-new.vue'
import MessageNot from '@/components/Message-notification.vue'
import AssetNew from "@/views/assets/AssetNew.vue"
import TradeDetail from "@/components/unilateral/Unilateral-task-detail.vue";
import ManulTrade from "@/components/unilateral/Unilateral-manul-form.vue";
import { mapState, mapActions } from 'vuex'
import { get } from '@/api/index' 
import { setTimeout } from 'timers';
import { getAssetChartDatas, getAssetStatic, getAssetApiChart,
 postAssetsRestore, postRestoreTask } from "@/api/api";
import apiUChart from "@/views/api/Api-chart.vue";

export default {
    components: {
        AssetChart,
        AssetCurrencyChart,
        MyProgress,
        MessageNot,
        AssetNew,
        NewProgress,
        AssetApiChart,
        apiUChart,
        TradeDetail,
        ManulTrade
    },
    data() {
        return{
            apiId: '',
            apiId1: '',
            statisticData: {},
            tableList: [],
            bourseId: 2,
            dialogVisible: false,
            chartData: {},
            apiSelected: 0,
            totalChecked: false,
            apiList: [],
            ApiLedgerList: [],
            apiBorrowData: [],

            isShow: false,
            borrowFlag: false,
            cFlag: 'u',
            selectList: [],
            tagActive: 'static',
            apiSelectList: [],
            apiStaticData: null,
            apiUchartData: null,
            apiDate: 3,
            apiCType: 'u',
            apiChartParam: {},
            tradeFormData: {},
            tabIndex: 0
        }
    },
    mounted() {
        this.initApiList(); 
    },
    beforeDestroy() {
        clearInterval(this.assets['assetsTimer']);
    },
    computed: {
        ...mapState([
            'apiNameList',
            'assetsTableHeader',
            'token',
            'assets',
            'assetData',
            'id',
            'assetChartData',
            'layout',
            'assetBorrowData'
        ]),
        // 计算(抵押已用+期货已用)/总净资产
        calUsedRate() {
            if (this.statisticData && this.statisticData['futures_used/surplus(USDT)'] && this.statisticData['borrow_pledge_used/surplus(USDT)']) {
                var future_used = this.statisticData['futures_used/surplus(USDT)'].split(':')[0];
                var borrow_used = this.statisticData['borrow_pledge_used/surplus(USDT)'].split(':')[0];
                var total_used = this.statisticData['total_equity(USDT)'];
                return {
                    'future': future_used,
                    'borrow': borrow_used,
                    'total': total_used
                }
            }
        },

        // thead 变化
        getHeader() {
            if (this.bourseId == 2) {
                var assetsHeadLen = this.assetsTableHeader.length;
                var new_assetHeader = [];
                if (assetsHeadLen == 22) {
                    this.assetsTableHeader.map((value, index) => {
                        if (index !== 12 && index !== 14) {
                            new_assetHeader.push(value);
                        }
                    })
                    return new_assetHeader;
                }
            };
            return this.assetsTableHeader;
        },
        // 默认背景颜色判断
        defaultColor() {
            return this.id.apiId;
        },  
        
        // 借贷记录
        ledgerFilter() {

        },
        isTable() {
            return typeof(statisticData) == 'undefined';
        }
    },
    methods: {
        ...mapActions([
            'getApiList',
            'createAssetSocket',
            'getApiDataList'
        ]),

        // 获取初始化 api 列表
        initApiList() {   
            getAssetApiChart({token: this.token}).then(res => {
                if (res.code == 200) {
                    this.apiUchartData = res.data;
                } else {
                    this.$notify.error({
                        title: '提示',
                        message: res.info,
                        offset: 100
                    });
                }
            })

            this.getApiList().then((initApiId, bourse_id, apiData) => {
                this.bourseId = bourse_id;
                for (var i=0; i<initApiId.length; i++) {
                    this.apiList.push(initApiId[i].id);
                }
                this.id.apiId = 0;
                this.apiChartParam = {
                    token: this.token,
                    layout: 3,
                    apiId: String(this.apiList)
                };
                this.getApiStaticData();
                
                if (!this.assets['assetSocket'] || !this.assets['assetSocket'].socket) {// websocket 连接已断开
                    this.createAssetSocket().then(socket => {

                        this.sendMsg();
                        this.assets['assetsTimer'] = setInterval(() => {
                            this.sendMsg();
                        }, 3000)
                    })
                } else {
                    this.sendMsg();
                    this.assets['assetsTimer'] = setInterval(() => {
                        this.sendMsg();
                    }, 3000)
                }
            });
        },

        // api 选择
        apiSelect(api, e, index) {
            this.id.apiId = api.id;
            this.bourseId = api.bourse_id;
            this.apiId = api.id;
            this.apiSelected = index;
            this.apiList = [this.id.apiId];
            this.assetBorrowData.ledger = [];
            this.assetBorrowData.borrow = [];
            this.apiChartParam.apiId = String(this.apiList);
            // this.getApiStaticData();
            this.handleTabData();
            this.sendMsg();
        },

        // 发送 函数
        sendMsg() {
            var param = {
                'token': this.token,
                'apiId': this.apiList
            };
            this.assets['assetSocket'].sendMsg(JSON.stringify(param)).then(resp => {
                if (resp.code == 200) {
                    if (resp.data.asset_info) {
                        this.statisticData = resp.data.asset_info.statistics;
                        this.tableList = resp.data.asset_info.list;
                    }

                    if (resp) {
                        this.assetBorrowData.ledger.push.apply(this.assetBorrowData.ledger, resp.data.ledger);
                        this.assetBorrowData.borrow.push.apply(this.assetBorrowData.borrow, resp.data.borrow);
                    }
                }
            }).catch(error => {
                console.warn(error);
            })
        },

        // statistic 字符串重新拼接
        dataProcess(data) {
            if (typeof data == 'undefined') return;
            var data_list = data.split(':');
            return data_list[0] + '/' + data_list[1] + '/' + data_list[2];
        },

        // 显示 曲线
        getAssetChart() {
            this.dialogVisible = true;
            if (typeof this.$refs.assetChart !== 'undefined') {
                this.$refs.assetChart.getAssetRateData();
            }
        },

        // api select 事件
        apiSelectEvent() {
            this.id.apiId = this.apiNameList[this.apiSelected].id;
            this.bourseId = this.apiNameList[this.apiSelected].bourse_id;
            this.apiId = this.apiNameList[this.apiSelected].id;
            this.apiList = [this.id.apiId];
            this.assetBorrowData.ledger = [];
            this.assetBorrowData.borrow = [];

            if (this.totalChecked == false) {
                this.sendMsg();
            }
        },

        // 获取资产图表快照
        getAssetChartData() {
            return new Promise((resolve, reject) => {
                var url = this.$baseUrl + '/asset/imaging/get';
                var param = {
                    'token': this.token,
                    'apiId': this.id.apiId,
                    'layout': this.layout
                };
                get(url, param).then(resp => {
                    if (resp.code == 200) {
                        this.$store.commit('initAssetChartData', resp.data);
                        resolve();
                    } else {
                        this.$notify.error({
                            message: resp.info,
                            title: '提示',
                            offset: 100
                        })
                    }
                })
            })
        },

        // 展示币种图表
        showCurrencyChart(currency, index) {
            var assetChartNode = this.$refs.assetChart1[index].$el;
            assetChartNode.style.width = $('.el-popover').width() + 'px';
            var myEchart = this.$echarts.init(assetChartNode);
            myEchart.clear();
            myEchart.showLoading({
                text: 'loading',
                color: '#c23531',
                textColor: '#000',
                maskColor: 'rgba(255, 255, 255, 0.8)',
                zlevel: 0
            })
            if (this.id.apiId == this.apiId1) {
                // 如果api 相同, 不用请求数据直接初始化表格
                this.$refs.assetChart1[index].initAssetsChart(currency, myEchart, assetChartNode);
            } else {
                // api不同，发起请求后在初始化表格, 使两个api相等
                this.getAssetChartData().then(() => {
                    this.$refs.assetChart1[index].initAssetsChart(currency, myEchart, assetChartNode);
                });
                this.apiId1 = this.id.apiId;
            }
        },

        // 计算资产比例
        assetsRate(data) {
            if (typeof data !== 'undefined') {
                var data_arr = data.split(' : ');
                var data_0 = Number(data_arr[0]);
                var data_1 = Number(data_arr[1]);
                var assetRate = data_0/(data_0 + data_1) * 100;
                var assetRateNum = Number(assetRate.toFixed(2));
                if (data_1 == 0) return 0;
                else if (assetRate == NaN) return 0;
                else if (assetRate == 0) return 0;
                return assetRateNum;
            }
        },

        // 图表时间切换
        changeChart(layout) {
            this.$store.commit('setAssetLayout', layout);
            this.$refs.assetChart.getAssetRateData(this.cFlag);
        },

        // 图表币类型切换
        currecncySelect(flag) {
            this.cFlag = flag;
            this.$store.commit('setCurrencyFlag', flag);
            this.$refs.assetChart.show_data_change(flag);
        },

        // 天数高亮
        dateTimeBgc(time) {
            if (time == this.layout) return '#DB5634';
            return '#969292';
        },

        // api 复选框事件
        apiTotalEvent() {
            var api_total_list = [];
            this.apiNameList.map(value => {
                api_total_list.push(value.id)
            })
            if (this.totalChecked == true) {// 所有api
                this.apiList = api_total_list;
            } else {
                this.apiList = [this.id.apiId];
            }
            // this.apiList = [0];
            this.sendMsg();
        },

        // 所有api总和
        apiTotalAsset() {
            var api_total_list = [];
            this.apiNameList.map(value => {
                api_total_list.push(value.id)
            });
            this.apiList = api_total_list;
            this.id.apiId = 0;
            this.apiChartParam.apiId = String(api_total_list);
            this.getApiStaticData();
            this.sendMsg();

        },

        // 获取 api 借款记录
        getApiBorrow(){
            var url = this.$baseUrl +'/asset/borrow/record/get';
            var param = {
                'token': this.token,
                'apiId': this.id.apiId
            };
            get(url, param).then(resp => {
                if (resp.code == 200) {
                    this.apiBorrowData = resp.data;
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        duration: 1000,
                        offset: 100
                    })
                }

            }) 
        },

        // 获取api转账记录
        getApiLedger() {
            var url = this.$baseUrl + '/asset/ledger/log/get';
            var param = {
                'token': this.token,
                'apiId': this.id.apiId
            };
            get(url, param).then(resp => {

                if (resp.code == 200) {
                    this.ApiLedgerList = resp.data;
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        duration: 1000,
                        offset: 100
                    })
                }
            })
        },

        // 图片币类型选择高亮
        currencyHigh(flag) {
            if (this.cFlag == flag) return '#db5634';
        },

        // 拍摄资产快照
        getSnapshot() {

            var url = this.$baseUrl+'/asset/manual/snapshot/get';
            var param = {
                token: this.token,
                apiId: this.id.apiId
            };

            get(url, param).then(res => {
                if (res.code === 200) {
                    this.$notify.info({
                        message: res.info,
                        title: '提示',
                        offset: 100
                    })
                } else {
                    this.$$notify.error({
                        message: res.info,
                        title: '提示',
                        offset: 100
                    })
                }
            })
        },

        // 多选框事件
        checkboxEvent(e, aid) {
            if (e) {
                if (this.apiSelectList.indexOf(aid) == -1) {
                    this.apiSelectList.push(aid);
                }
            } else {
                this.apiSelectList.remove(aid);
            }
        },

        handleTabClick(e) {// 选项卡切换事件
            this.tabIndex = e.index;

            if (this.tabIndex == 0) {// api 统计
                this.apiChartParam.apiId = String(this.apiList);
            }

            this.handleTabData();
        },

        getApiStaticData() {// 获取api统计数据
            this.$refs.apiChart.getChartData(this.apiChartParam);
        },

        handleTabData() {// 处理tab触发
            if (this.tabIndex == 0) {// api 统计
                this.$nextTick(() => {
                    this.$refs.apiChart.getChartData(this.apiChartParam);
                })
            } else if (this.tabIndex == 1) {// 交易记录
                this.$nextTick(() => {
                    this.$refs.tradeNode.update(this.id.apiId);
                });
            }
        },

        apiChartChange(val) {// api 统计数据切换
            this.apiDate = val;
            this.apiChartParam.layout = val;
            this.getApiStaticData();
        },

        apiTypeChange(val) {
            this.apiCType = val;
            this.$nextTick(() => {
                this.$refs.apiChart.updateChart(val);
            })
        },

        handleRestore() {// 继续跟随
            this.$confirm('是否继续跟随！', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const apiId = this.id.apiId;
                let param = {
                    token: this.token,
                };
                String(apiId) == "0" ? param.apiId = String(this.apiList) : param.apiId = String(apiId);
                // console.log('param ', param);
                postRestoreTask(param).then(res => {
                    this.$notify.info({
                        title: '提示',
                        message: res.info,
                        offset: 200
                    });
                })
            }).catch(err => {
                console.warn('Error: ', err);
            })


            //postRestoreTask

            // var formData = new FormData();
            // formData.append('token', '142536');
            // formData.append('api_ids', apiId);
            // console.log('apiId ', apiId);

            // postAssetsRestore(formData).then(res => {
            //     this.$notify.info({
            //         title: '提示',
            //         message: '操作成功',
            //         offset: 200
            //     });
            // })
        },
    }
}
</script>

<style lang="scss">
    .assets-page{
        ::-webkit-scrollbar{
            width: 12px;
        }
        ::-webkit-scrollbar-track{
            // color: #1e1e1e;
            box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
            // border-radius: 10px;
            background-color: #2A2D2E;
        }
        ::-webkit-scrollbar-thumb{
            border-radius: 10px;
            background: rgba(122, 121, 121, 0.1);
            box-shadow: inset 0 0 6px rgba(124, 124, 124, 0.5);
        }
        .borrow-log{
            color: #A7A7A7;
            background-color: #2a2d2e;
            h3{
                background-color: #262829;
                text-align: left;
                padding: 3px;
                margin-bottom: 10px;
            }
            table{
                border-collapse: collapse;
                text-align: left;
                height: 140px;
                thead{
                    background-color: #262829;
                    tr th{
                        padding: 5px 5px;
                    }
                }
                tbody{
                    background-color: #2a2d2e !important;
                    
                    tr{
                        td{
                            padding: 3px 3px;
                            font-size: 12px;
                        }
                    }
                    tr:hover{
                        background-color: #1e1e1e;
                        color: #fff;
                    }
                }
            }
            table tbody{
                display: block;
                height: 103px;
                overflow-y: scroll;
            }
            table thead, tbody tr{
                display: table;
                width: 100%;
                table-layout: fixed;
            }           
        }
        .el-progress-circle__track{
            stroke: #3c3b3b;
        }
        .el-container{
            padding: 0 !important;
            .el-aside{
                // min-width: 150px;
                width: 150px !important;
                background-color: #2A2D2E;
                .menu-title{
                    padding: 10px;
                    color: #686869;
                    text-align: left;
                    background-color: #1e1e1e;
                }
                .el-menu{
                    background-color: #2A2D2E;
                    border: 0;
                    .el-menu-item{
                        color: #A7A7A7;
                        font-size: 13px;
                        padding: 3px;
                        line-height: 30px;
                        height: 30px;
                        text-align: left;
                        padding-left: 5px !important;
                    }
                    .el-menu-item:hover{
                        background-color: #575656;
                        color: #fff;
                    }
                }
            }
            .el-container{
                background-color: #2A2D2E;
                margin: 0 !important;
                padding: 0 !important;
                .el-main{
                    text-align: left;
                    color: #686869;
                    background-color: #252425 !important;
                    .table-title {
                        color: #A7A7A7 !important;
                    }
                    .classify-content {
                        margin-right: 10px;
                        margin-left: 10px;
                        margin-top: 10px;
                        display: flex;
                        justify-content: space-between;
                        background-color: #212223;
                        ul {
                            background-color: #212223;
                            display: flex;
                            justify-content: flex-start;
                            flex-flow: wrap;
                            li {
                                padding: 3px 5px;
                                margin-right: 4px;
                                background-color: #262829;
                                margin-bottom: 5px;
                            }
                            li:hover {
                                cursor: pointer;
                                color: #fff;
                            }
                            .el-checkbox__inner{
                                background-color: #3e403f;
                                border: 1px solid #b1b1b1;
                            }
                        }
                    }
                    .table-description{
                        font-size: 13px;
                        padding: 15px 10px;
                        padding-top: 10px;
                        color: #A7A7A7;
                        display: flex;
                        flex-wrap: wrap;
                        p{
                            padding: 3px;
                        }
                        div{
                            text-align: center;
                        }
                        .borrow-log{
                            min-width: 360px;
                            flex: 1;
                        }
                        .borrow-content {
                            flex: 1.4;
                            box-shadow: 0 0 2px #000;
                            .borrow-content-title {
                                background-color: #262829;
                                text-align: left;
                                // padding: 2px 0px;
                                margin-bottom: 3px;
                                display: flex;
                                button {
                                    flex: 1;
                                    outline: none;
                                    // border-radius: 3px;
                                    border: 0;
                                    // margin-right: 5px;
                                    font-size: 13px;
                                    padding: 2px 5px;
                                    background-color: #262829;
                                    color: #969292;
                                }
                                button:hover {
                                    cursor: pointer;
                                    color: #fff;
                                }
                            }
                            #pane-static {
                                text-align: left;
                                >div{
                                    display: inline-block;
                                    vertical-align: top;
                                }
                                .static-info{
                                    text-align: left;
                                    padding-left: 10px;
                                    ul>li{
                                        line-height: 1.8;
                                        padding: 5px;
                                    }
                                }
                            }
                            .el-tabs__content {
                                background-color: #2a2d2e;
                                .el-tab-pane {
                                    overflow-y: scroll;
                                    height: 200px;
                                    thead>tr{
                                        background-color: #262829;
                                    }
                                }
                                .el-tab-pane:nth-child(2) {
                                    overflow-y: auto;
                                }
                            }
                            .el-tabs--border-card>.el-tabs__header{
                                background-color: #262829;
                                border-bottom: 1px solid #262829;
                            }
                            .el-tabs--border-card{
                                border: none;
                                box-shadow: 0 2px 4px 0 rgba(0,0,0,0), 0 0 6px 0 rgba(0,0,0,0);
                            }
                            .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{
                                color: #db5634;
                                background-color: #2a2d2e;
                                border-right-color: #2a2d2e;
                                border-left-color: #2a2d2e;
                            }
                        }
                        .asset-total{
                            margin-right: 2px; 
                            flex: 1;
                            min-width: 560px;
                            background-color: #2a2d2e;
                            box-shadow: 0 0 2px #000;
                            .asset-item-name{
                                width: 210px;
                                text-align: left;
                            }
                            h3{
                                background-color: #262829;
                                text-align: left;
                                padding: 3px;
                                margin-bottom: 10px;
                            }
                            .asset-total-box{
                                .asset-total-title {
                                    padding: 5px;
                                    background-color: #262829;
                                    text-align: left;
                                    display: flex;
                                    .asset-title-item {
                                        flex: 1;
                                        text-align: left;
                                    }
                                }
                                .asset-total-body{
                                    .asset-total-item{
                                        display: flex;
                                        justify-content: flex-start;
                                        padding: 4px 5px;
                                        span{
                                            margin-right: 5px;
                                        }
                                    }
                                }
                            }

                        }
                        .borrow-info{
                            flex: 1;
                            background-color: #2a2d2e;
                            min-width: 350px;
                            .borrow-info-header{
                                padding: 5px;
                                background-color: #262829;
                            }
                            .borrow-info-body{
                                height: 160px;
                                overflow-y: scroll; 
                            }
                            .borrow-info-item{
                                font-size: 12px;
                                text-align: left;
                                padding: 5px;
                            }
                        }
                        table{
                            table-layout: fixed;
                            width: 100%;
                            tbody{
                                background-color: #262829;
                                height: 133px;
                                tr{
                                    td{
                                        padding: 5px;
                                        .el-progress{
                                            margin-left: 10px;
                                        }
                                        .el-progress-bar__outer{
                                            width: 100px;
                                            border-radius: 0;
                                            background-color: #5a6361;
                                            .el-progress-bar__inner{
                                                border-radius: 0;
                                                .el-progress__text{
                                                    font-size: 12px;
                                                }
                                            }
                                        } 
                                    }
                                    .asset-value-td{
                                        min-width: 100px;
                                    }
                                }
                            }
                           
                        }
                        .table-description-item{
                            text-align: left;
                            display: flex;
                            justify-content: flex-start;
                            .el-progress{
                                line-height: 18px;
                                margin-left: 10px;
                            }
                            .el-progress-bar__outer{
                                width: 100px;
                                border-radius: 0;
                                background-color: #48a090;
                                .el-progress-bar__inner{
                                    border-radius: 0;
                                    .el-progress__text{
                                        font-size: 12px;
                                    }
                                }
                            }
                        }
                    }
                    .table-title{
                        // padding: 5px;
                        display: flex;
                        justify-content: space-between;
                        border-bottom: 1px solid #1e1e1e;
                        background-color: #1e1e1e;
                        .table-title-contral{
                            .el-badge{
                                margin-right: 10px;
                                .el-badge__content{
                                    background-color: #db5634;
                                    border: 1px solid #db5634;
                                    height: 12px;
                                    line-height: 12px;
                                    padding: 0 2px;
                                    top: 3px;
                                    right: 7px;
                                }
                                span{
                                    font-size: 12px;
                                }
                                span:hover{
                                    cursor: pointer;
                                    color: #969292;
                                }
                            }
                        }
                        .el-dialog__body{
                            background-color: #262829;
                            box-shadow: 0 0 10px #6f6c6c;
                        }
                        .chart-time-select{
                            text-align: center;
                            margin-top: 10px;
                            span{
                                margin-right: 10px;
                                color: #969292;
                            }
                            span:hover{
                                cursor: pointer;
                            }
                        }
                        .table-title-left{
                            display: flex;
                            justify-content: flex-start;
                            > span {
                                margin-right: 10px;
                            }
                            select{
                                margin: 0 10px;
                                background-color: #333333;
                                border: 1px solid #333333;
                                color: #969292;
                            }
                            .el-checkbox{
                                margin-left: 10px;
                                .el-checkbox__label{
                                    padding-left: 5px;
                                }
                            }
                            .el-input__inner{
                                height: 25px;
                                line-height: 25px;
                                font-size: 12px;
                                padding-right: 20px;
                                background-color: #262829;
                                border-color: #262829;
                                color: #A7A7A7;
                            }
                            .el-input__icon{
                                line-height: 25px;
                            }

                        }
                        // .el-button{
                        //     padding: 5px 10px;
                        //     color: #969292;
                        //     background-color: #333333;
                        //     border-color: #333333;
                        // }
                        // .el-button:hover{
                        //     color: #fff;
                        // }
                        .chart-title{
                            padding: 10px;
                            h3{
                                text-align: center;
                            }
                            .chart-select {
                                display: flex;
                                justify-content: center;
                                .el-divider {
                                    margin-top: 13px;
                                    background-color: #969292;
                                }
                            }
                        }
                    }
                    .table-content{
                        padding: 0 0 0 0px;
                        overflow-x: scroll;
                        margin-bottom: 60px;
                        table{
                            font-size: 13px;
                            border-collapse: collapse;
                            width: 100%;
                            color: #A7A7A7;
                            min-width: 1100px;
                            // table-layout: fixed;
                            thead{
                                background-color: #262829;
                                tr{
                                    th{
                                        padding: 8px 0px;
                                        text-align: right;
                                        font-weight: 600;
                                        color: #A7A7A7;
                                        min-width: 70px;
                                    }
                                    th:first-child {
                                        min-width: 40px;
                                    } 
                                }
                            }
                            tbody{
                                background-color: #2A2D2E;
                                tr{
                                    td{
                                        padding: 10px 0px;
                                        border: 1px solid #353434;
                                        text-align: right;
                                        font-size: 13px;
                                        color: #A7A7A7;
                                        .el-button{
                                            padding: 0;
                                            background-color: #2A2D2E;
                                            border-color: #2A2D2E;
                                            color: #A7A7A7;
                                        }
                                    }

                                }
                                tr:nth-child(even) {
                                    background-color: #262829;
                                }
                                tr:hover{
                                    background-color: #262829;
                                    td{
                                        color: #fff;
                                    }
                                }
                            }
                        }
                    }
                    
                }
            }
            
        }
        .active1{
            // box-shadow: inset 0 0 10px #7d7b7b;
            // background-color: #252425 !important;
            // box-shadow: inset 0 0 10px #000000;
            color: #db5634;
        }
    }

    @media screen and (max-width: 1200px) {
        table{
            tr{
                td{
                    padding: 5px 0px !important;
                    font-size: 13px !important;
                }
            }
        }
        .assets-page{
            .el-container{
                padding: 20px 5px;
                .el-aside{
                    display: none;
                }
                .el-container{
                    margin-left: 0;
                    padding: 10px 0;
                    .el-main{
                        .table-title{
                            .table-title-left{
                                h3{
                                    font-size: 0.6rem;
                                }
                                h3:hover {
                                    cursor: pointer;
                                }
                                .el-input__inner{
                                    padding-right: 1px;
                                    padding-left: 5px;
                                }
                            }
                            .el-button{
                                padding: 3px 5px;
                                font-size: 12px;
                            }
                        }
                        .table-description{
                            padding: 5px 10px;
                            font-size: 12px;
                            .borrow-log {
                                table {
                                    tr {
                                        td {
                                            padding: 5px !important;
                                        }
                                    }
                                }
                            }
                        }
                        .table-content{
                            width: 100%; 
                            overflow-x: scroll;
                            table{
                                thead{
                                    tr{
                                        th{
                                            font-size: 12px;
                                        }
                                    }
                                }
                                tbody{
                                    tr td{
                                        font-size: 12px;
                                        span{
                                            .el-button{
                                                font-size: 12px;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        .table-description {
                            padding: 5px 0 !important;
                            .asset-total {
                                min-width: 420px !important;
                                overflow-x: scroll;
                                .asset-total-box {
                                    min-width: 630px;
                                }
                            }
                        }
                        .classify-content {
                            margin: 5px 0 0 0 !important;
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width: 680px) {
        .assets-page{
            .el-dialog{
                width: 350px !important;
            }
            .message-notification{
                display: none;
            }
            .el-container {
                .el-main {
                    .table-description {
                        padding: 5px 0 !important;
                        .asset-total {
                            min-width: 420px !important;
                            overflow-x: scroll;
                            .asset-total-box {
                                min-width: 600px;
                            }
                        }
                    }
                    .classify-content {
                        ul {
                            display: none;
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width: 420px) {
        .assets-page{
            .el-container{
                padding: 0px;
                margin: 0 3px;
                .el-main {
                    .table-description{
                        display: block !important;
                        flex-direction: column;
                        // overflow-x: scroll;
                        padding: 5px 0 !important;
                        width: 100%;
                        .asset-total, .borrow-log, .borrow-info{
                            flex: 0;
                            margin-bottom: 10px;
                        }
                        .asset-total {
                            min-width: 360px !important;
                            .asset-item-name {
                                width: 180px !important;
                            }
                        }
                    }
                }
                .classify-content {
                    margin: 5px 0 0 0 !important;
                    ul {
                        display: none !important;
                    }
                }
                .table-content {
                    margin-bottom: 20px;
                    table{
                        thead{
                            tr{
                                th{
                                    padding: 8px 5px;
                                    text-align: right;
                                    font-weight: 600;
                                    color: #A7A7A7;
                                    min-width: 70px;
                                }
                            }
                        }
                    }
                }
                .asset-total{
                    min-width: 363px !important;
                    overflow-x: scroll;
                    width: 100% !important;
                    .asset-total-box{
                        // overflow-x: scroll;
                        // width: 100%;
                        width: 400px;
                        .asset-total-body{
                            .asset-total-item{
                                .assets-item-value{
                                    width: 200px;
                                    min-width: 200px;
                                    text-align: left;
                                    margin-right: 0 !important;
                                }
                                .asset-item-progress{
                                    min-width: 85px;
                                }
                                .asset-item-name{
                                    min-width: 160px;
                                }
                            }
                        }
                    }
                }
                .borrow-log{
                    min-width: 263px !important;
                }
                .table-title-left{
                    h3{
                        i{
                            display: none;
                        }
                    }
                }
            }
            .el-checkbox{
                display: none;
            }

            .asset-total .borrow-log{
                margin-bottom: 5px;
            }
            
        }
    }
    
</style>
